import { createClient } from "@supabase/supabase-js";

// Supabase configuration
// Note: In Create React App (CRA), env variables start with REACT_APP_
// In Vite, they start with VITE_. Checking both for flexibility.
const supabaseUrl = process.env.REACT_APP_SUPABASE_URL || (window as any).VITE_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY || (window as any).VITE_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  const message = '[AdMesh] Missing Supabase env variables. Configure REACT_APP_SUPABASE_URL and REACT_APP_SUPABASE_ANON_KEY.';
  if (process.env.NODE_ENV === 'test') {
    console.warn(message);
  } else {
    throw new Error(message);
  }
}

// Initialize Supabase with performance optimizations for OAuth
export const supabase = createClient(supabaseUrl!, supabaseAnonKey!, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
    flowType: 'pkce',
    storageKey: 'admesh-developer-auth',
  }
});
